{
  "version": 1,
  "asset_id": "3f69fa8f-e884-44f0-82e6-915d4ca44f3e",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/3f69fa8f-e884-44f0-82e6-915d4ca44f3e/loc-the-woodlands-1280.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/3f69fa8f-e884-44f0-82e6-915d4ca44f3e/loc-the-woodlands-1280.webp",
  "original_filename": "loc-the-woodlands-1280.webp",
  "size": 101864,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:26:34Z"
}
